import React from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';

function Footer({ tenant }) {
    return (
        <div>
            <AppBarComponent cssClass='e-appbar' colorMode="Primary" style={tenant !== null && tenant.secondaryColour !== '' ? { background: tenant.secondaryColour, height: '70px' } : { height: '60px', background: `#2A8BFF` }}>
                <span className="text-white " style={{ marginLeft: '10px', fontSize: '14px' }}>&copy; {new Date().getFullYear()} {tenant !== null ? tenant.name : "campaigns.org.uk"}. All rights reserved.</span>

                <div className="e-appbar-spacer"></div>

                {tenant && tenant.logoUrl !== '' ?
                    (
                        <div className="my-2">
                            <img src={tenant.logoUrl !== '' ? tenant.logoUrl : "./logo.svg"} style={{ height: 90, objectFit: 'contain', width: '100%', alignSelf: 'center', zIndex: '100', padding: '10px' }} alt={tenant !== null ? tenant.name : "campaigns.org.uk"} />
                        </div>

                    ) : (<div className="my-2">
                        <img src="./logo.svg" style={{ height: '50px', width: '50px', objectFit: 'contain', alignSelf: 'center', zIndex: '100', padding: '10px' }} alt="campaigns.org.uk" />
                    </div>)}
            </AppBarComponent>  
        </div>

    );
}

export default Footer;